const CircleLocationIcon = ({ className }) => {
  return (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <rect width="48" height="48" rx="24" fill="#FF0000" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M24 18.75C21.6528 18.75 19.75 20.6528 19.75 23C19.75 25.3472 21.6528 27.25 24 27.25C26.3472 27.25 28.25 25.3472 28.25 23C28.25 20.6528 26.3472 18.75 24 18.75ZM21.25 23C21.25 21.4812 22.4812 20.25 24 20.25C25.5188 20.25 26.75 21.4812 26.75 23C26.75 24.5188 25.5188 25.75 24 25.75C22.4812 25.75 21.25 24.5188 21.25 23Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M24 13.25C18.7245 13.25 14.25 17.6095 14.25 22.9258C14.25 25.6482 15.4019 27.9241 17.0169 29.8025C18.625 31.6728 20.7183 33.1811 22.6782 34.3944L22.6911 34.4024L22.7043 34.4098C23.0996 34.6329 23.546 34.75 24 34.75C24.454 34.75 24.9004 34.6329 25.2957 34.4098L25.3072 34.4033L25.3185 34.3964C27.2855 33.1928 29.3793 31.6796 30.9866 29.8038C32.6003 27.9206 33.75 25.6392 33.75 22.9258C33.75 17.6095 29.2755 13.25 24 13.25ZM15.75 22.9258C15.75 18.4564 19.5344 14.75 24 14.75C28.4656 14.75 32.25 18.4564 32.25 22.9258C32.25 25.183 31.3014 27.1311 29.8476 28.8277C28.3908 30.5279 26.4534 31.9424 24.5482 33.1092C24.3809 33.2014 24.1922 33.25 24 33.25C23.8083 33.25 23.6202 33.2017 23.4533 33.11C21.5487 31.93 19.6117 30.5197 18.1543 28.8246C16.7001 27.1332 15.75 25.1912 15.75 22.9258Z"
        fill="white"
      />
    </svg>
  );
};

export default CircleLocationIcon;
